import { useState, useMemo, useCallback } from "react";
import { Card, Row, Col, Typography, Flex, Image, Pagination } from "antd";
import { BTN_TXT } from "../../../constants/constants";
import { DEAL_CARD_PAGE_SIZE } from "../../../constants/tableConfig";
import CustomButton from "../../../components/CustomButton/Button";
import {
  truncateDescription,
  formatCurrency,
  formatDate,
  capitalizeWords,
} from "../../../helpers/helpers";

const { Title, Text } = Typography;

const NewDeals = ({ newdeals }) => {
  const [expandedDeals, setExpandedDeals] = useState({});
  const [currentPage, setCurrentPage] = useState(1);

  const toggleDescription = useCallback((dealId) => {
    setExpandedDeals((prev) => ({
      ...prev,
      [dealId]: !prev[dealId],
    }));
  }, []);

  const paginatedDeals = useMemo(() => {
    const deals = newdeals ?? [];
    const start = (currentPage - 1) * DEAL_CARD_PAGE_SIZE;
    return deals.slice(start, start + DEAL_CARD_PAGE_SIZE);
  }, [newdeals, currentPage]);

  const totalDeals = newdeals?.length ?? 0;

  return (
    <>
      <Row gutter={[16, 16]}>
        {paginatedDeals.map((deal) => (
          <Col xs={24} lg={12} key={deal.deal_id}>
            <Card className="deal-card">
              <Flex justify="space-between" align="center" wrap="wrap">
                <Flex align="center" gap="middle">
                  <Image
                    src={deal.ent_logo}
                    alt="Ent Logo"
                    height={80}
                    width={120}
                    preview={false}
                  />
                  <Title level={5}>{deal.ent_name}</Title>
                </Flex>

                <Text className="deal-status">
                  Deal Status:{" "}
                  <span className="deal-status-tag">
                    {capitalizeWords(deal.deal_status)}
                  </span>
                </Text>
              </Flex>

              <div className="ent-description-container">
                <Text className="ent-description">
                  {expandedDeals[deal.deal_id]
                    ? deal.ent_discription
                    : truncateDescription(deal.ent_discription, 150)}

                  <CustomButton
                    type="link"
                    style={{ padding: 0, marginLeft: 5, fontSize: 12 }}
                    onClick={() => toggleDescription(deal.deal_id)}
                  >
                    {expandedDeals[deal.deal_id]
                      ? BTN_TXT.READ_LESS
                      : BTN_TXT.READ_MORE}
                  </CustomButton>
                </Text>
              </div>

              <div className="deal-constraint-container">
                <div className="deal-constraint-details">
                  <Text style={{ fontSize: 12, color: "#40566d" }}>
                    Deal ID:
                  </Text>
                  <Title level={5}>{deal.deal_id}</Title>
                </div>
                <div className="deal-constraint-details">
                  <Text style={{ fontSize: 12, color: "#40566d" }}>
                    Approved Amount
                  </Text>
                  <Title level={5}>
                    {formatCurrency(deal.approved_fund_amt)}
                  </Title>
                </div>
                <div className="deal-constraint-details">
                  <Text style={{ fontSize: 12, color: "#40566d" }}>
                    Disbursed Amount
                  </Text>
                  <Title level={5}>{formatCurrency(deal.disbursed_amt)}</Title>
                </div>
                <div className="deal-constraint-details">
                  <Text style={{ fontSize: 12, color: "#40566d" }}>
                    Repaid Amount
                  </Text>
                  <Title level={5}>{formatCurrency(deal.repaid_amt)}</Title>
                </div>
                <div className="deal-constraint-details">
                  <Text style={{ fontSize: 12, color: "#40566d" }}>
                    Due Date
                  </Text>
                  <Title level={5}>{formatDate(deal.due_date)}</Title>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
      {totalDeals > DEAL_CARD_PAGE_SIZE && (
        <Pagination
          current={currentPage}
          pageSize={DEAL_CARD_PAGE_SIZE}
          total={totalDeals}
          onChange={setCurrentPage}
          style={{ marginTop: 16, textAlign: "center" }}
          showSizeChanger={false}
        />
      )}
    </>
  );
};

export default NewDeals;
